export default "__VITE_ASSET__BNfXA3ZF__"